import { Http } from '../../../support';

const initialState = {
  isValid: false,
  busy: false,
  fetching: false,
  result: undefined,
  error: undefined,
  data: {},
  steps: [],
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.receptores.upsert = {
      ...state.app.receptores.upsert,
      ...data,
    };
  });
};

const _isValid = (steps) => {
  return steps.every((value) => !!value.done);
};

const _getNewStepsAfterVerification = (all, step, valid) => {
  return all.map((item) => {
    const assignable = { ...item };

    if (step.number === assignable.number) {
      assignable.done = valid;
    }

    return assignable;
  });
};

const setStepDataChange = (store, event, callback) => {
  const { upsert } = store.state.app.receptores;

  const steps = _getNewStepsAfterVerification(upsert.steps, event.step, event.isValid);

  store.setState((state) => {
    state.app.receptores.upsert = {
      ...state.app.receptores.upsert,
      data: { ...event.data },
      steps: steps,
      isValid: _isValid(steps),
    };
  }, callback);
};

const upsert = async (store, data, id, options = {}) => {
  store.setState((state) => {
    state.app.receptores.upsert.busy = true;
  });

  try {
    const { upsert } = store.state.app.receptores;

    const headers = {
      'X-Tenancy': upsert.tenancy || undefined,
    };

    const params = {
      include: 'series,nomina',
    };

    let response = null;

    if (!id) {
      response = await Http.post(`api/receptores`, data, { headers, params });
    } else {
      response = await Http.put(`api/receptores/${id}`, data, { headers, params });
    }

    store.setState((state) => {
      state.app.receptores.upsert.busy = false;
      state.app.receptores.upsert.result = response;
      state.app.receptores.upsert.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.receptores.upsert.busy = false;
      state.app.receptores.upsert.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.receptores.upsert = { ...initialState };
  });
};

const ReceptorUpsertStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    setStepDataChange,
    upsert,
    reset,
  },
};

export default ReceptorUpsertStore;
